import { List } from "antd-mobile"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import InstructionItems from "../Instruction/InstructionItems"
import FeedbackBtns from "../hotFaq/FeedbackBtns"
import ContactDialog from "../../../components/dialog/ContactDialog"
import WechatDialog from "../../../components/dialog/WechatDialog"
import { useRef } from "react"

const AddConnect = props => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const contactDlgRef = useRef(null)
    const wechatDlgRef = useRef(null)

    const handleFeedback = () => {
        window.ReactNativeWebView.postMessage('feedback')
    }

    const handleContact = () => {
        contactDlgRef.current?.show()
    }

    return <div className="tab-content">
        <div style={{ background: 'white', borderRadius: 16 }}>
            <List mode='card'>
                <List.Item onClick={() => {
                    navigate('/bind_device_faq')
                }}>
                    {t('bind_device_faq_title')}
                </List.Item>
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('/connect_wifi')
                }}>
                    {t('how_connect_wifi')}
                </List.Item>
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('/share_permission')
                }}>
                    {t('share_permission')}
                </List.Item>
                {/* <div className='seperate' /> */}
                {/* <List.Item onClick={() => {
                    navigate('./add_device')
                }}>
                    {t('how_add_device')}
                </List.Item>
                <div className='seperate' />
                <List.Item onClick={() => {
                    navigate('./connect_fail')
                }}>
                    {t('cannot_connect_camera')}
                </List.Item> */}
            </List>
        </div>

        <InstructionItems />
        <FeedbackBtns onFeedbackClick={handleFeedback} onContactClick={handleContact} />
        <ContactDialog ref={contactDlgRef} onPhoneClick={() => {
            window.ReactNativeWebView.postMessage('400-069-0588')
        }} onWechatClick={() => {
            contactDlgRef.current?.dismiss()
            wechatDlgRef.current?.show()
        }} />
        <WechatDialog ref={wechatDlgRef} />
    </div>
}

export default AddConnect